import React, { useState, useEffect } from "react";
import { NavLink as NavLinkBase, useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { buyersGuideSidebarRoutes, sidebarRoutes as routesDPS } from "../../../routes/index";
import { setSubRoute } from "../../../redux/actions/navigation";

import { IoClose } from "react-icons/io5";

// CSS STYLES
import styles from '../../../styles/shared/Sidebar.module.css'
// IMAGES
const dpsLogo = '/static/img/ImsLogos/DPS-Logo.png';
const ManageContentIcon = '/static/img/SvgIcons/manageContentMainIcon.svg';






const SidebarNEW = ({  
    isMobile,
    open,
    onClose, 
    setSubRoute,
    isBuyersGuide,
    // REDUX REDUCERS
    auth: { 
        isAuthenticated, 
        accountUser 
    },
    navigation: {
        subRoute
    }
}) => {


    const navigate = useNavigate()
    const { pathname } = useLocation()

    const [search, setSearch] = useState('')

    //   let displayRoutes = site === 'DPS' ? routesDPS : site === 'DL' ? routesDL : routesDXP;
    let displayRoutes = pathname?.includes('/buyers-guide/') ? buyersGuideSidebarRoutes : routesDPS;

    const SidebarSingleRoute = ({ route, idx, disabled }) => {
        return (
            <div
                key={`${route.id}-${idx}`} 
                className={`${styles.sidebar_single_link} ${pathname.startsWith(route.path) ? styles.sidebar_selected : ''} ${disabled ? styles.sidebar_link_disabled : ''}`}
                onClick={() => handleLink(route.path, disabled)}
            >
                <p className={styles.single_link_title}>{route.id}</p>
                <img src={route.icon ? route.icon : ManageContentIcon} alt="IMS Logo" className={styles.single_link_icon} />
            </div>
        );
    };

    const SidebarTabsRoute = ({ route, open, idx, disabled }) => {

        const handleClick = (route) => {
            if (disabled) {
                return
            }
            
            if (route.accessParam && !accountUser?.hasAccess?.includes(route.accessParam)) {
                return
            }

            if (route.path !== pathname) {
                handleLink(route.path)
            }

            const tab = route.tab ? route : route.tabs[0]
            setSubRoute(tab?.tab)
        }

        return (
            <div
                key={`${route.id}-${idx}`} 
                className={`${styles.sidebar_multi_link_container}  ${pathname.startsWith(route.path) ? styles.sidebar_selected : ''}`}
                
            >   
                <div onClick={() => handleClick(route)} className={`${styles.sidebar_multi_link} ${disabled ? styles.sidebar_link_disabled : ''}`}>
                    <p className={styles.single_link_title}>{route.id}</p>
                    <img src={route.icon ? route.icon : ManageContentIcon} alt="IMS Logo" className={styles.single_link_icon} />
                </div>
                {open ?
                    route.tabs.map((routeTabs, index) => (
                        <p 
                            className={`${styles.sidebar_sub_link} ${(disabled || (routeTabs.accessParam && !accountUser?.hasAccess?.includes(routeTabs.accessParam))) ? styles.sidebar_link_disabled : ''} ${routeTabs.path === pathname && subRoute === routeTabs.tab ? styles.sidebar_sub_selected : ''}`}
                            key={`routeTabs-${idx}-${index}`} 
                            onClick={() => routeTabs.tab ? handleClick(routeTabs) : routeTabs.path ? handleLink(routeTabs.path, disabled) : {}}
                        >
                            {routeTabs.name}
                        </p>
                    ))
                : null}
            </div>
        );
    };

    const SidebarChildrenRoute = ({ route, open, idx, disabled }) => {

        const handleClick = (route) => {
            if (disabled) {
                return
            }

            if (route.accessParam && !accountUser?.hasAccess?.includes(route.accessParam)) {
                return 
            }

            if (route.path !== pathname) {
                handleLink(route.path)
            }
        }

        return (
            <div
                key={`${route.id}-${idx}`} 
                className={`${styles.sidebar_multi_link_container} ${pathname.startsWith(route.path) ? styles.sidebar_selected : ''}`}
            >   
                <div onClick={() => handleClick(route)} className={`${styles.sidebar_multi_link} ${disabled ? styles.sidebar_link_disabled : ''}`}>
                    <p className={styles.single_link_title}>{route.id}</p>
                    <img src={route.icon ? route.icon : ManageContentIcon} alt="IMS Logo" className={styles.single_link_icon} />
                </div>
                {open ?
                    route.children.map((routeChild, index) => routeChild.isBasePath ? null : (
                        <p 
                            className={`${styles.sidebar_sub_link} ${(disabled || (routeChild.accessParam && !accountUser?.hasAccess?.includes(routeChild.accessParam))) ? styles.sidebar_link_disabled : ''} ${routeChild.path === pathname ? styles.sidebar_sub_selected : ''}`}
                            key={`routeChild-${idx}-${index}`} 
                            onClick={() => handleClick(routeChild)}
                        >
                            {routeChild.name}
                        </p>
                    ))
                : null}
            </div>
        );
    };

    const handleLink = (path, disabled) => {
        if (disabled) {
            return
        }

        navigate(path)
    }

    // FILTER NAV WITH TABS OR CHILDREN
    const handleFilterSubRoutes = (route, subRoute) => {
        const subContent = route[subRoute].filter(e => e.name && e.name.toLowerCase().includes(search.toLowerCase()))

        if (!(subContent.length > 0)) {
            return null
        }

        return {
            ...route,
            [subRoute] : subContent
        }
    }

    // FILTER NAV BY SEARCH TEXT
    const filterRoutes = (route) => {
        if (!search) {
            return route
        }
        
        if (route.children?.length > 0) {
            return handleFilterSubRoutes(route, 'children')

        } else if (route.tabs?.length > 0) {
            return handleFilterSubRoutes(route, 'tabs')

        } else if (route.id && route.id.toLowerCase().includes(search)) {
            return route

        } else {
            return null
        }
    }

    return  !isMobile ? (

        <div className={styles.sidebar_main_container}>
            {/* DL LOGO */}
            <div className={styles.logo_container}>
                <img src={dpsLogo} alt="IMS Logo" className={styles.sidebar_logo} />
            </div>
            
            <NavigationSearch search={search} setSearch={setSearch} />

            {/* ALL LINKS/ROUTES CONTAINER */}
            <div className={styles.sidebar_links_container}>
            {
                displayRoutes && displayRoutes.map((route, idx) => {

                    const filteredRoute = filterRoutes(route)
                    const userHasAccess = accountUser?.hasAccess?.includes(route.accessParam) || !route.accessParam ? true : false

                    return filteredRoute ? (
                        route.children?.length > 0 ? 
                            <SidebarChildrenRoute key={`${idx}-sidebar`} route={filteredRoute} idx={idx} open={(pathname && route.basePath && pathname.includes(route.basePath)) || search} disabled={!userHasAccess}/>
                        : route.tabs?.length > 0 ? 
                            <SidebarTabsRoute key={`${idx}-sidebar`} route={filteredRoute} idx={idx} open={(pathname && route.path && pathname.includes(route.path)) || search} disabled={!userHasAccess}/>
                        :
                            <SidebarSingleRoute key={`${idx}-sidebar`} route={filteredRoute} idx={idx} disabled={!userHasAccess}/>
                    ) : null
                })
            }
            </div>


        </div>

    ) : isMobile && open ? (
        <div className={styles.sidebar_mobile_wrapper} onClick={() => onClose()}>

        
        <div className={styles.sidebar_mobile_container}>
            {/* DXP LOGO */}
            <div className={styles.logo_container}>
                <img src={dpsLogo} alt="IMS Logo" className={styles.sidebar_logo} />
            </div>

            <NavigationSearch search={search} setSearch={setSearch} />

            {/* ALL LINKS/ROUTES CONTAINER */}
            <div className={styles.sidebar_links_container}>

                {
                    displayRoutes && displayRoutes.map((route, idx) => {
                        
                        const filteredRoute = filterRoutes(route)
                        const userHasAccess = accountUser?.hasAccess?.includes(route.accessParam) || !route.accessParam ? true : false
                        return filteredRoute ? (
                            route.children?.length > 0 ? 
                                <SidebarChildrenRoute key={`${idx}-sidebar`} route={filteredRoute} idx={idx} open={(pathname && route.basePath && pathname.includes(route.basePath)) || search} disabled={!userHasAccess}/>
                            : route.tabs?.length > 0 ? 
                                <SidebarTabsRoute key={`${idx}-sidebar`} route={filteredRoute} idx={idx} open={(pathname && route.path && pathname.includes(route.path)) || search} disabled={!userHasAccess}/>
                            :
                                <SidebarSingleRoute key={`${idx}-sidebar`} route={filteredRoute} idx={idx} disabled={!userHasAccess}/>
                        ) : null
                    })
                }
                
            </div>
        </div>

    </div>
    ) : (null);
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    navigation: state.navigation,
});

export default connect(mapStateToProps, {
    setSubRoute
})(SidebarNEW);
// export default withRouter(connect(mapStateToProps, {})(Sidebar));


const NavigationSearch = ({ search, setSearch }) => {

    const preventPropagation = (e) => {
        e.stopPropagation()
    }

    return (
        <div className={styles.sidebar_search_container} 
        onClick={e => preventPropagation(e)}
        >
            <div className={styles.sidebar_search_input_container}>
                <label>Navigation Search</label>
                <input 
                    type='text'
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className={styles.sidebar_search}
                    placeholder="Navigation Search"
                />
                {search ?
                    <div className={styles.sidebar_clear_search} onClick={() => setSearch('')}>
                        <IoClose  size={20}/>
                    </div>
                : null}
            </div>
        </div>
    )
}
